import { useState, useEffect } from 'react';

export default function Console ( { text } ){
  const [displayedText, setDisplayedText] = useState(``);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  const speed = 50;

  const ascii = ` .---.  .-----. .--. 
  /   __| |  ___| \\  \`'  \\    Console
  |  /    |  __|   >   <     -------
  |  \\__  |  |    /  .  \\  
   \\____| |__|   /__/ \\__\\ `;

  const restartEffect = () => {
    setDisplayedText(``);
    setCurrentIndex(0);
    setIsComplete(false);
  };

  useEffect(() => {
    restartEffect();
  }, [text]);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeoutId = setTimeout(() => {
        setDisplayedText(prev => prev + text.charAt(currentIndex));
        setCurrentIndex(prev => prev + 1);
        
        if (currentIndex === text.length - 1) {
          setIsComplete(true);
        }
      }, speed);

      return () => clearTimeout(timeoutId);
    }
  }, [currentIndex, text, speed]);

  return (
    <div className = "console" onMouseEnter = { () => { if (isComplete) { restartEffect(); } } }>
      <p className = "consoleP">{ displayedText }
        <span className = "consoleBlink"></span>
      </p>

      <div style = { { display : "flex", gap : "8px", alignItems : "center" } }>
        <p className = "consoleAscii">{ ascii }</p>
      </div>
    </div>
  );
};